import { get, patch, post } from "./../Config/config";

export const NotificationsApi = {
  list: (params) => get("/notifications", { params }),
  unreadCount: () => get("/notifications/unread-count"),
  markRead: (id) => patch(`/notifications/${id}/read`),
  readAll: () => post("/notifications/read-all"),
};
